import axios from "axios";

export default {
  reset(payload) {
    return axios.post("crm/logistics/admin/password/reset", payload);
  },
};
